import type { Transaction } from '@api/hooks/types/getTransactions';
import { Direction } from '@api/hooks/types/getTransactions';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { OperationStatus } from 'types/operations';

import { LabeledField } from './LabeledField';

export const OperationCellMobile = ({
	beneficiary,
	status,
	payment_details,
	execution_date,
	amount,
	direction,
}: Transaction) => {
	const { t } = useTranslation();

	return (
		<div className="flex flex-col gap-space-16">
			<LabeledField label={t('listOfOperations.table.beneficiary')}>
				<div className="flex flex-col">
					<div className="flex items-center gap-space-4">
						<span className="text-sm-bold text-neutral-950">{beneficiary.name}</span>
						{status === OperationStatus.FAILED && (
							<span className="text-xs-bold text-status-error-700 bg-brand-primary-50 rounded-full px-space-8 h-5 inline-flex items-center shrink-0">
								{t('listOfOperations.paymentStatuses.failed')}
							</span>
						)}
					</div>
					<span className="text-sm-medium text-neutral-600">
						{beneficiary.account_number}
					</span>
				</div>
			</LabeledField>

			<LabeledField label={t('listOfOperations.table.description')}>
				<span className="text-sm-medium text-neutral-950">{payment_details}</span>
			</LabeledField>

			<LabeledField label={t('listOfOperations.table.date')}>
				<span className="text-sm-bold text-neutral-950">{execution_date}</span>
			</LabeledField>

			<LabeledField label={t('listOfOperations.table.amount')}>
				<span
					className={clsx(
						'text-sm-bold',
						direction === Direction.INWARD
							? 'text-brand-secondary-700'
							: 'text-neutral-950',
					)}
				>
					{direction === Direction.INWARD ? '+' : '-'}
					{Math.abs(amount).toLocaleString('lt-LT', { minimumFractionDigits: 2 })}
				</span>
			</LabeledField>
		</div>
	);
};
